import React from 'react';
import { Card, Box, Chip, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

export default function VisibilityFilterSidebar({
  showLocked,
  showRemoved,
  setShowLocked,
  setShowRemoved,
}) {
  const items = [
    { label: 'Show Locked', value: showLocked, toggle: setShowLocked },
    { label: 'Show Removed', value: showRemoved, toggle: setShowRemoved },
  ];

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
        <FilterListIcon fontSize="small" color="success" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Filters
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: 1.5,
          rowGap: 1.5,
          mt: 2,
          ml: 2,
          mr: 2,
        }}
      >
        {items.map((item) =>
          item.value ? (
            <Chip
              key={item.label}
              label={item.label}
              variant="outlined"
              color="success"
              onDelete={() => item.toggle(false)}
              sx={{
                px: 1,
                py: 2,
                '& .MuiChip-label': { fontSize: '0.85rem', fontWeight: 'normal' },
                '& .MuiChip-deleteIcon': { fontSize: '1.2rem' },
              }}
            />
          ) : (
            <Chip
              key={item.label}
              label={item.label}
              variant="outlined"
              color="success"
              onClick={() => item.toggle(true)}
              sx={{
                backgroundColor: 'transparent',
                px: 1,
                py: 2,
                '& .MuiChip-label': {
                  fontSize: '0.85rem',
                  color: 'text.primary',
                  fontWeight: 'normal',
                },
              }}
            />
          )
        )}
      </Box>
    </Card>
  );
}
